import { Button } from "@/components/ui/button";
import { Phone, ArrowRight } from "lucide-react";
import { BRAND } from "@/lib/brand";
import { trackPhoneCallLead } from "@/lib/ads";

export default function MobileCTA() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 gap-px border-t border-border bg-background/95 backdrop-blur-md lg:hidden">
      <Button asChild variant="outline" className="h-14 rounded-none border-0 text-sm font-semibold">
        <a href={`tel:${BRAND.phoneTel}`} onClick={trackPhoneCallLead}><Phone className="mr-1.5 h-4 w-4" /> Call Now</a>
      </Button>
      <Button asChild className="h-14 rounded-none text-sm font-semibold bg-accent text-white hover:bg-accent/90">
        <a href="#booking">Book Treatment <ArrowRight className="ml-1 h-4 w-4" /></a>
      </Button>
    </div>
  );
}